export enum BrandingAnnouncementTileTypeEnum{
    TileWithRibbon = 1,
    TileWithSpecialDesign = 2
}